import React from "react";
import { eapiClient } from "../../../restClient";
import { Translations, isEmptyObject } from "../../../utils";
import Button from "../../common/Btn";
import Checkbox from "../../common/Checkbox";
import DropdownContainer from "../../common/Dropdown/DropDown";
import InputTextbox from "../../common/InputBox/inputTextbox";
import { getStatusForPutApi } from "../../createASow/ProductMapping";

class CaptureAccountDetails extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            formJson: (this.props.accountDetailsFormJson && this.props.accountDetailsFormJson.guideContainer &&
                this.props.accountDetailsFormJson.guideContainer.rootPanel.items) || {},
            entities: this.props.entities,
            accounts: [this.getAccountObj()],
            thirdPartyAccounts: [this.getAccountObj(true)],
            invalidFields: {},
            deletedAccounts: []
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.accountDetailsFormJson && nextProps.accountDetailsFormJson.guideContainer && nextProps.accountDetailsFormJson.guideContainer.rootPanel &&
            nextProps.accountDetailsFormJson.guideContainer.rootPanel.items)
            this.setState({ formJson: nextProps.accountDetailsFormJson.guideContainer.rootPanel.items });
    }

    componentWillMount() {
        this.getAccountInfo()
    }

    isReadOnly = () => {
        return this.props.customer || this.props.isCustAck || (this.props.isReadOnly && this.props.isReadOnly())
    }
    getAccountInfo = () => {
        this.props.blockUi && this.props.blockUi()
        const apiUrl = `/sows/${this.props.activeEntity && this.props.activeEntity.id}/sow-account-info`
        eapiClient(apiUrl, {
            method: 'GET'
        }).then(response => {
            this.props.unBlockUi && this.props.unBlockUi()
            const { data } = response || {}
            if (Array.isArray(data.responseData) && data.responseData.length) {
                const thirdPartyAccounts = data.responseData.filter(acc => Boolean(acc.isThirdPartyAccount))
                const accounts = data.responseData.filter(acc => !Boolean(acc.isThirdPartyAccount))
                this.setState({
                    accounts,
                    thirdPartyAccounts
                })
            }
        })
    }

    getAccountObj = (thirdParty = false) => {
        let accountObj = {
            accountNumber: '',
            location: {},
            currency: {},
        }
        if (thirdParty) {
            accountObj = { ...accountObj, countryOfIncorporation: {}, location: "" }

        } else {
            accountObj = { ...accountObj, isNewAccount: false }
        }
        return accountObj
    }

    handleAddAccount = (formName) => {
        if (formName) {
            this.setState({ [formName]: [...this.state[formName], this.getAccountObj(formName === "thirdPartyAccounts" ? true : false)] })
        }
    }

    handleDeleteAccount = (formName, formIndex) => {
        if (this.isReadOnly()) {
            return
        } else {
            if (formName) {
                const newAccounts = [...this.state[formName]]
                newAccounts.splice(formIndex, 1)
                this.setState({ [formName]: [...newAccounts] })
            }
            if (this.state[formName] && this.state[formName][formIndex] && this.state[formName][formIndex].id) {
                this.setState({
                    deletedAccounts: [...this.state.deletedAccounts, this.state[formName][formIndex].id]
                })
            }
        }

    }

    handleFormChange = (e, target, formName, formIndex) => {
        const newAccounts = [...this.state[formName]]
        if (newAccounts[formIndex]) {
            newAccounts[formIndex][target] = e.target && e.target.type === "checkbox" ? e.target.checked : e
            this.setState({ [formName]: [...newAccounts] })
        }
    }

    addAccountButtonJsx = (accounts = [], formName, label = "Add Account") => {
        return this.handleShowAddAccount(accounts) ?
            <section>
                <button class="gdocs-btn-default" id={"add-" + formName + this.state[formName].length + 1} onClick={(e) => { e.preventDefault(); this.handleAddAccount(formName) }}
                    disabled={this.isReadOnly()}>
                    <span class="icon icon-add addicon" aria-hidden="true">
                    </span>{`${label} ${this.state[formName].length + 1}`}
                </button>
            </section> : null
    }

    handleShowAddAccount = (accounts = []) => {
        let flag = true
        accounts.map(acc => {
            if (flag === false) {
                return
            }
            let mandatoryFields = ["accountNumber", "currency", "location"]
            if (!("isNewAccount" in acc)) {
                mandatoryFields.push("countryOfIncorporation")
            }
            mandatoryFields.map(mandatory => {
                if (flag === false) {
                    return
                }
                flag = typeof acc[mandatory] === "object" ? !isEmptyObject(acc[mandatory]) : Boolean(acc[mandatory])
            })
        })
        return flag
    }

    getTranslation = (word) => {
        return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    }

    saveButtonJSx = () => {
        const buttonProps = (this.state.formJson && this.state.formJson.guidebutton_save) || {}

        return <section className="gdocs-align-self-end">
            <Button {...buttonProps}
                translatedText={this.getTranslation(buttonProps.text)}
                _onClick={() => this.handleFormSubmit()}
                disabled={this.isReadOnly() || (!this.validateAccounts(this.state.accounts).length)}
            /></section>
    }

    handleFormSubmit = (apiUrl = `/sows/${this.props.activeEntity && this.props.activeEntity.id}/sow-account-info`) => {
        this.props.blockUi && this.props.blockUi()
        let payLoad = {
            accounts: [...this.validateAccounts(this.state.accounts), ...this.validateAccounts(this.state.thirdPartyAccounts, false)]
        }
        if (this.state.deletedAccounts) {
            payLoad = {
                accounts: [...payLoad.accounts.map(acc => ({ ...acc, status: acc.id ? getStatusForPutApi.update : getStatusForPutApi.added })),
                ...this.state.deletedAccounts.map(id => ({ id, status: getStatusForPutApi.delete }))]
            }
        }
        eapiClient(apiUrl, {
            method: 'PUT',
            data: JSON.stringify(payLoad)
        }).then(({ data }) => {
            this.props.unBlockUi && this.props.unBlockUi()
            const { responseData } = data || {}
            if (responseData) {
                const thirdPartyAccounts = responseData.filter(acc => Boolean(acc.isThirdPartyAccount))
                const accounts = responseData.filter(acc => !Boolean(acc.isThirdPartyAccount))
                this.setState({
                    accounts,
                    thirdPartyAccounts,
                    deletedAccounts: []
                })
                this.props.getTabStatus && this.props.getTabStatus()
            }
        })
    }

    handleFormValidation = (field, isValid) => {
        const newInvalidFields = { ...this.state.invalidFields }
        if (isValid === "inValid") {
            newInvalidFields.field = isValid
        }
        else if (isValid === "valid") {
            delete newInvalidFields.field
        }
        this.setState({ invalidFields: newInvalidFields })
    }

    isAccountEmpty = (account, hsbc = true) => {
        let flag = true
        const mandatoryFields = {
            hsbc: ["accountNumber", "currency", "location"],
            thirdParty: ["accountNumber", "countryOfIncorporation", "location", "currency"]
        }
        mandatoryFields[hsbc ? "hsbc" : "thirdParty"].forEach(field => {
            if (flag === false) {
                return
            }
            flag = isEmptyObject(account[field])

        })
        return flag
    }

    validateAccounts = (accounts, hsbc = true) => accounts.map(acc => {
        return this.isAccountEmpty(acc, hsbc) ? undefined : hsbc ? { ...acc } : { ...acc, isThirdPartyAccount: true }
    }).filter(el => el) || []

    render() {
        return (
            <React.Fragment>
                <article className="form-container sow-account-details">
                    {this.state.accounts.length ?
                        this.state.accounts.map((account, accountIndex) => (
                            <AggregateComponent
                                formJson={this.state.formJson && this.state.formJson.guideaggregateformbox_addAccount}
                                accountsTaxonomies={this.props.accountsTaxonomies}
                                handleFormChange={this.handleFormChange}
                                lang={this.props.lang && this.props.lang.currentLang && this.props.lang.currentLang.lang}
                                translatedData={this.props.lang && this.props.lang.translatedData}
                                formData={account}
                                handleDeleteAccount={this.handleDeleteAccount}
                                handleAddAccount={this.handleAddAccount}
                                formIndex={accountIndex}
                                getTranslation={this.getTranslation}
                                handleFormValidation={this.handleFormValidation}
                                idPrefix={this.props.idPrefix}
                                key={this.props.idPrefix + "-acc" + accountIndex}
                                customer={this.props.customer}
                                isCustAck={this.props.isCustAck}
                                isReadOnly={this.isReadOnly}
                            >
                            </AggregateComponent>
                        ))
                        : null
                    }
                    {this.addAccountButtonJsx(this.state.accounts, "accounts")}
                    <hr></hr>
                    {this.state.thirdPartyAccounts.length ? this.state.thirdPartyAccounts.map(((account, accountIndex) => (
                        <AggregateComponent formJson={this.state.formJson && this.state.formJson.guideaggregateformbox_addThirdPartyAccount}
                            accountsTaxonomies={this.props.accountsTaxonomies}
                            handleFormChange={this.handleFormChange}
                            lang={this.props.lang && this.props.lang.currentLang && this.props.lang.currentLang.lang}
                            translatedData={this.props.lang && this.props.lang.translatedData}
                            formData={account}
                            handleDeleteAccount={this.handleDeleteAccount}
                            handleAddAccount={this.handleAddAccount}
                            formIndex={accountIndex}
                            getTranslation={this.getTranslation}
                            handleFormValidation={this.handleFormValidation}
                            idPrefix={this.props.idPrefix}
                            key={this.props.idPrefix + "-acc" + accountIndex}
                            customer={this.props.customer}
                            isCustAck={this.props.isCustAck}
                            isReadOnly={this.isReadOnly}
                        >
                        </AggregateComponent>
                    )))
                        : null}
                    {this.addAccountButtonJsx(this.state.thirdPartyAccounts, "thirdPartyAccounts", "Add Third party account")}
                    {this.saveButtonJSx()}
                </article>
            </React.Fragment>


        )
    }
}

export const getAggregateFormComponents = (value, lang, translatedData) => {
    let formComponents;
    if (value) {
        formComponents = JSON.parse(Translations(value, lang, translatedData) || JSON.stringify(value));
    } else {
        formComponents = [];
    }
    return formComponents;
}

export const AggregateComponent = ({ formJson = {}, formIndex, accountsTaxonomies = {}, handleFormChange, handleFormValidation,
    handleDeleteAccount, formData = {}, lang = '', translatedData = {}, getTranslation, idPrefix = "", key = "", customer, isCustAck, isReadOnly = () => { } }) => {
    const { components, name: formName } = formJson
    const componentList = getAggregateFormComponents(components, lang, translatedData)
    const componentJsx = componentList.map((component, componentIndex) => {
        const { fieldType = '', name = '', type = '', label = '', apiUrl = '', title = '', header = '', mandatory = "", mandatoryMessage } = component
        switch (fieldType) {
            case 'dropDownSelect':
                return (
                    <React.Fragment>
                        <section className="form-row-container" key={key + "-dd" + componentIndex}>
                            <section className="form-row-label">
                                <label htmlFor={`${formName}_${formIndex}_${name}_${componentIndex}`}>
                                    {getTranslation(label)}
                                </label>
                            </section>
                            <section className="form-row-field">
                                <DropdownContainer
                                    ddname={`${formName}_${formIndex}_${name}_${componentIndex}`}
                                    id={`${idPrefix}-${formName}_${formIndex}_${name}_${componentIndex}`}
                                    setDropdownvalue={(value) => { handleFormChange(value, name, formName, formIndex) }}
                                    value={formData[name]["value"]}
                                    optionTextSelector={"name"}
                                    type={type}
                                    taxonomies={accountsTaxonomies}
                                    properties={{ editType: "gls-sow-add-account" }}
                                    formData={formData}
                                    mandatory={mandatory}
                                    mandatoryMessage={getTranslation(mandatoryMessage)}
                                    setFieldValidtionState={(field, isValid) => {
                                        handleFormValidation(field, isValid)
                                    }}
                                    disabled={customer || isCustAck || isReadOnly()}
                                />
                            </section>
                        </section>
                    </React.Fragment>
                )

            case "inputField":
                return (
                    <React.Fragment>
                        <section className="form-row-container" key={key + "-in" + componentIndex}>
                            <section className="form-row-label">
                                <label htmlFor={`${formName}_${formIndex}_${name}_${componentIndex}`}>
                                    {getTranslation(label)}
                                </label>
                            </section>
                            <section className="form-row-field">
                                <InputTextbox
                                    name={`${formName}_${formIndex}_${name}_${componentIndex}`}
                                    id={`${idPrefix}-${formName}_${formIndex}_${name}_${componentIndex}`}
                                    setInputvalue={(value) => { handleFormChange(value, name, formName, formIndex) }}
                                    type={type}
                                    _value={formData[name] || ''}
                                    mandatory={mandatory}
                                    mandatoryMessage={getTranslation(mandatoryMessage)}
                                    setFieldValidtionState={(field, isValid) => {
                                        handleFormValidation(field, isValid)
                                    }}
                                    disabled={customer || isCustAck || isReadOnly()}
                                ></InputTextbox>
                            </section>
                        </section>
                    </React.Fragment>

                )
            case "checkBox":

                return (
                    <React.Fragment>
                        <section className="form-row-container" key={key + "-ch" + componentIndex}>
                            <section className="form-row-checkbox">
                                <Checkbox
                                    name={`${idPrefix}-${formName}_${formIndex}_${name}_${componentIndex}`}
                                    onChange={(e) => {
                                        handleFormChange(e, name, formName, formIndex)
                                    }}
                                    checked={formData[name] || false}
                                    controlled
                                    disabled={customer || isCustAck || isReadOnly()}
                                ></Checkbox>
                            </section>
                            <section className="form-row-checkbox-label">
                                <label htmlFor={`${formName}_${formIndex}_${name}_${componentIndex}`}>
                                    {getTranslation(label)}
                                </label>
                            </section>
                        </section>
                    </React.Fragment>
                )
            case "formTitle":
                return (
                    <article key={key + "-tt" + componentIndex}>
                        {header ? <section><strong>
                            {getTranslation(header)}</strong></section> : null}
                        <section>
                            {`${getTranslation(title)} ${formIndex + 1}`}
                        </section>
                    </article>
                )
            default:
                break;
        }
    }
    )
    const deleteIconJsx = formIndex > 0 ? <section class={isReadOnly() ? "disabled delete-icon" : "delete-icon"} id={formName + "_" + formIndex} onClick={() => {
        handleDeleteAccount(formName, formIndex)
    }}><i tabindex="0" class="icon icon-bin"></i></section> : null


    return (
        <React.Fragment>
            <section className="add-account">
                {componentJsx}
                {deleteIconJsx}
            </section>
        </React.Fragment>)
}

export default CaptureAccountDetails


// WEBPACK FOOTER //
// ./src/components/SowBody/CustomerDetails/CaptureAccountDetails.js